import React, { useState, useEffect } from "react";
import { Post } from "src/services/ClientSideAPIService";
import { validateEmailFormat } from "../../helpers/Helper";
import { useAppContext } from "@components/Provider";

import styles from "./ForgotPassword.module.css";
import "./ForgotPassword.css";

const ForgotPassword = (props) => {
  const { siteId, router } = useAppContext() || {};
  const [email, setEmail] = useState("");
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [onForgotPasswordSuccess, setOnForgotPasswordSuccess] = useState(false);

  const submitClick = () => {
    if (validateEmailFormat(email)) {
      let redirectTo = router?.query?.redirectTo || "";
      const params = { email, redirectTo };
      setRequestInProgress(true);
      setErrorMessage("");
      Post(
        "Forgot-Password",
        { data: params, siteid: siteId },
        onSuccess,
        onError
      );
    } else {
      setErrorMessage("Please enter valid email!");
    }
  };

  const onSuccess = (response) => {
    if (response.error) {
      onError(response);
    } else {
      setRequestInProgress(false);
      setOnForgotPasswordSuccess(true);
      setErrorMessage("");
    }
  };

  const onError = (error) => {
    if (error) {
      let serverError = error;
      let errorMsg =
        serverError !== undefined
          ? serverError.error
          : "Reset Password request failed";
      setErrorMessage(errorMsg);
      setRequestInProgress(false);
      setOnForgotPasswordSuccess(false);
    }
  };

  const handleEnterKeyPress = (event) => {
    const { which, keyCode } = event;
    if (which === 13 || keyCode === 13) {
      submitClick();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEnterKeyPress);
    return () => window.removeEventListener("keydown", handleEnterKeyPress);
  }, [handleEnterKeyPress]);

  const handleBackButtonClick = () => {
    props.backButtonClicked("forgotpassword");
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.loginBox}>
        <div className={styles.forgotHeader}>
          {props.isNonClosable && (
            <a className={styles.backButton} onClick={handleBackButtonClick}>
              Back
            </a>
          )}
          <h2 className={styles.heading}>Forgot Password?</h2>
        </div>

        {ErrorMessage && <div className={styles.errorMsg}>{ErrorMessage}</div>}

        {onForgotPasswordSuccess ? (
          <div className={styles.successBox}>
            <h3>Thank you, your reset password link has been sent!</h3>
            <p>
              Check your email for instructions on how to change your password.
            </p>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitClick();
            }}
          >
            <label className={styles.label}>Email</label>
            <input
              type="email"
              placeholder="somebody@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.input}
            />

            <button
              type="submit"
              className={styles.submitBtn}
              disabled={requestInProgress}
            >
              {requestInProgress ? "Submitting..." : "Submit"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
